import React, { useState } from "react";
import FileDownload from "js-file-download";
import sweetAlert from "sweetalert";

import { Page, Breadcrumbs, Panel, Loading } from "components";
import { Campaigns } from "components/Filters";

import cube from "services/cube";

import "./styles.scss";

const BREADCRUMBS = [
  { name: "Home", to: "/" },
  { name: "Extração", to: "/extraction" },
  { name: "Extração - Vouchers Abandonados", to: "" },
];

function AbandonedVouchers() {
  const [campaign, setCampaign] = useState(null);
  const [loading, setLoading] = useState(false);

  function handleSubmit(campaignId) {
    if (!campaignId) {
      return sweetAlert("Ops!", "Selecione uma campanha", "warning");
    }

    setLoading(true);

    const requestOptions = {
      params: { campaign_id: campaignId },
      responseType: "blob",
    };

    cube
      .get("/extraction/abandoned_vouchers", requestOptions)
      .then((response) => {
        FileDownload(response.data, `abandoned_vouchers_${campaignId}.csv`);
        sweetAlert("Sucesso!", "Arquivo gerado com sucesso", "success");
      })
      .catch((error) => {
        console.error(error);

        if (error.message.includes('503')) {
          return sweetAlert("Ops!", "A requisição atingiu o tempo limite. Tente novamente.", "info");
        }

        sweetAlert("Ops, algo deu errado", "Não foi possível gerar o arquivo", "error");
      })
      .finally(() => {
        setCampaign(null);
        setLoading(false);
      });
  }

  return (
    <Page className="page-exportation">
      <Breadcrumbs breadcrumbs={BREADCRUMBS} />

      <header className="page-exportation-header">
        <Page.Title>Extração - Vouchers Abandonados</Page.Title>
      </header>

      <Panel className="panel-list">
        <div className="exporation-form">
          <div className="container-campaign">
            <Campaigns
              placeholder="Campanha Comercial"
              value={campaign}
              onChange={(value) => setCampaign(value)}
            />
          </div>

          <button
            type="button"
            disabled={loading}
            onClick={() => handleSubmit(campaign ? campaign.value : null)}
          >
            {loading ? (
              <Loading type="btn" size="small" text="Buscando..." />
            ) : (
              "Exportar dados"
            )}
          </button>
        </div>
      </Panel>
    </Page>
  );
}

export default AbandonedVouchers;
